<template>
  <div>
    <div class="modal-body mb-n3">
      <div class="row" v-for="images in imageChunks">
        <div v-for="image in images" class="col col-3 mb-3">
          <div class="row">
            <div class="col-6">
              <label class="cursor-pointer d-flex align-items-center form-label">
                <input type="checkbox" class="pt-1 me-2"
                       @change="toggleSelectedImage(image)"
                       :checked="isSelected(image)"
                       :disabled="!isSelected(image) && selectedImages.length >= maxCount" />
                <strong v-if="isSelected(image)">Vybraná</strong>
                <template v-else>Vybraná</template>
              </label>
            </div>
          </div>
          <img :src="image.url" @click="toggleSelectedImage(image)" class="img-fluid img-thumbnail cursor-pointer">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="confirmSelection()" type="button" class="btn btn-primary">Potvrdit vybrané</button>
      <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Storno</button>
    </div>
  </div>
</template>

<script lang="ts">
import {chunk} from 'lodash-es';
import naja from 'naja';
import {computed, defineComponent, PropType, ref} from 'vue';

interface EstateImage {
    id: string;
    url: string;
}

export default defineComponent({
    props: {
        images: {
            type: Array as PropType<EstateImage[]>,
            required: true,
        },
        picked: {
            type: Array as PropType<EstateImage[]>,
            default: () => [],
        },
        url: {
            type: String,
            required: true,
        },
        // The most photos the document shows (IEstateDocumentProvider::MAX_PHOTOS)
        maxCount: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const selectedImages = ref<EstateImage[]>([]);

        const imageChunks = computed((): EstateImage[][] => {
            return chunk(props.images, 4);
        });

        // created logic
        const pickedIds = props.picked.map((image) => image.id);
        selectedImages.value = props.picked.length > 0
            ? props.images.filter((image) => pickedIds.includes(image.id))
            : props.images.slice(0, props.maxCount);

        function toggleSelectedImage(toggledImage: EstateImage): void {
            if (isSelected(toggledImage)) {
                selectedImages.value = selectedImages.value.filter((image) => image.id !== toggledImage.id);
                return;
            }

            if (selectedImages.value.length >= props.maxCount) {
                alert(`Vybrat můžete maximálně ${props.maxCount} obrázků`);
                return;
            }

            selectedImages.value = [...selectedImages.value, toggledImage];
        }

        function isSelected(image: EstateImage): boolean {
            return selectedImages.value.some((selected) => selected.id === image.id);
        }

        function confirmSelection(): void {
            if (selectedImages.value.length === 0) {
                alert('Je třeba vybrat alespoň jednu fotografii');
                return;
            }

            if (selectedImages.value.length > props.maxCount) {
                alert(`Vybrat můžete maximálně ${props.maxCount} obrázků`);
                return;
            }

            const data = {
                selectedImages: JSON.stringify(selectedImages.value),
            };

            naja.makeRequest('POST', props.url, data);
        }

        return {
            selectedImages, imageChunks,
            toggleSelectedImage, isSelected, confirmSelection,
        };
    },
});
</script>
